import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — a self-mounted side-effect that resets the window
 * scroll position to 0 whenever the route changes.
 *
 * React Router does NOT scroll to the top on navigation by default,
 * so a deep link / a click on a long page would otherwise leave the
 * user stranded mid-page. We don't preserve scroll because each
 * marketing page is a fresh starting point, not a continuation.
 *
 * Mount this once, near <Routes> in the router tree.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // `instant` so the user doesn't see the previous page scroll up
    // before the new page paints — feels like a clean hard navigation.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return null;
}
